<form [formGroup]="connectionForm">
        <div class="title" mat-dialog-title>Add Private Key</div>
        <div class="dialog-body">
            <div class="body-content">
                <div class="form-text">You will need to create a Private Key on Klaviyo app portal <a
                        href="https://developers.klaviyo.com/en/docs/retrieve_api_credentials"
                        target="_blank" data-cy="klaviyo-api-guide-link">this link</a>.</div>
                <mat-form-field appearance="outline" class="form-field">
                    <mat-label>Klaviyo Private Key</mat-label>
                    <input type="password" matInput placeholder="Enter Klaviyo Private Key" formControlName="privateKey"
                        data-cy="klaviyo-password-input">
                    <mat-error *ngIf="connectionForm.get('privateKey').hasError('required')">This field is required
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="dialog-footer">
            <div>
                <button mat-raised-button class="rubii-btn add-btn" color="primary" (click)="connect()"
                    data-cy="klaviyo-dialog-connect-data-btn">Connect Data
                    Source</button>
            </div>
        </div>
</form>